module.exports = __webpack_public_path__ + "media/images/bnr_amazon_pc-dfbcc5da46603e1e3a0a72abfdb3957e.png";